import { motion } from "framer-motion";
import { SERVICES } from "../../constants/data";
import { SectionHeading, Reveal } from "../Reveal";

export const Services = () => (
  <section id="services" data-testid="services-section" className="py-24 lg:py-32 bg-brand-mist/60">
    <div className="max-w-7xl mx-auto px-5 lg:px-8">
      <div className="max-w-2xl">
        <SectionHeading title="Complete home care, tailored to every need" />
        <Reveal delay={0.15}>
          <p className="mt-6 text-lg leading-relaxed text-slate-600">
            From personal care and companionship to specialized dementia and palliative support, BMS offers a complete range of home care services. Every service is delivered by caring professionals and tailored to the unique needs, routines, and preferences of each client.
          </p>
        </Reveal>
      </div>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {SERVICES.map((s, i) => (
          <motion.div
            key={s.title}
            initial={{ opacity: 0, y: 26 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.6, delay: (i % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
            whileHover={{ y: -4 }}
            data-testid={`service-card-${s.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            className="group flex items-start gap-4 rounded-2xl border border-slate-200 border-l-4 border-l-transparent bg-white p-5 hover:border-l-brand-teal hover:shadow-[0_16px_40px_rgb(11,27,61,0.08)] transition-shadow duration-300"
          >
            <div className="shrink-0 inline-flex h-12 w-12 items-center justify-center rounded-full bg-brand-teal/10 text-brand-teal group-hover:bg-brand-teal group-hover:text-white transition-colors duration-300">
              <s.icon className="h-5 w-5" strokeWidth={1.5} />
            </div>
            <div>
              <h3 className="font-display text-lg leading-snug text-brand-navy">{s.title}</h3>
              <p className="mt-1.5 text-[15px] leading-relaxed text-slate-600">{s.desc}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
